import {
  AfterContentInit,
  AfterViewInit,
  ChangeDetectionStrategy,
  Component,
  OnDestroy,
  TemplateRef,
  inject,
  input,
  viewChild,
  computed,
} from '@angular/core';
import { SideNavService } from './sidenav.service';
import { MatSidenav, MatSidenavContainer } from '@angular/material/sidenav';
import { MenuToggleButtonComponent } from '../menu-toggle/menu-toggle-button/menu-toggle-button.component';
import { NgTemplateOutlet } from '@angular/common';

@Component({
  selector: 'mulo-sidenav',
  templateUrl: './sidenav.component.html',
  styleUrls: ['./sidenav.component.scss'],
  changeDetection: ChangeDetectionStrategy.Default,
  host: {
    class: 'mulo-sidenav',
    '[class.is-fixed]': 'this.fixedInViewport()',
  },
  imports: [
    MatSidenavContainer,
    MatSidenav,
    MenuToggleButtonComponent,
    NgTemplateOutlet,
  ],
})
export class SidenavComponent
  implements AfterContentInit, AfterViewInit, OnDestroy
{
  service = inject(SideNavService);

  readonly hasBackdrop = input(true);
  readonly fixedInViewport = input(true);
  readonly autoFocus = input(true);
  readonly position = input<'start' | 'end'>(null);
  readonly mode = input<'over' | 'push' | 'side'>('over');
  readonly id = input<string>(undefined);
  readonly template = input<TemplateRef<any>>(undefined);
  readonly closeButtonText = input<string | null>('Close');
  readonly closeButtonIcon = input<string | null>('close');
  readonly closeButtonMode = input<'absolute' | 'relative' | 'hidden'>(
    'relative',
  );
  readonly closeButtonSide = input<'left' | 'right'>('right');

  readonly sidenav = viewChild('sidenav', { read: MatSidenav });

  serviceContent = computed(() =>
    this.service.content()?.id === this.id() ? this.service.content() : null,
  );
  computedTemplate = computed(
    () => this.serviceContent()?.template ?? this.template(),
  );

  ngAfterContentInit() {
    this.sidenav()._animationEnd.subscribe((ev: any) => {
      this.service.onSidenavAnimationDone(ev?.toState);
    });
  }

  ngAfterViewInit(): void {
    this.service.setSidenav(this.sidenav(), this.id());
  }

  ngOnDestroy(): void {
    this.service.unloadSidenav(this.id());
  }

  public close() {
    this.service?.close(this.id());
  }
}
